export const baseUrl_ = process.env.REACT_APP_TBH_BACKEND_API;
export const swqtk = process.env.REACT_APP_PAYMENT_GATEWAY_API;
export const landingPageUrl = process.env.REACT_APP_TBH_FRONTEND_URL;
export const dashboardPageUrl = process.env.REACT_APP_TBH_DASHBOARD_FRONTEND_URL;
export const timeout = Number(process.env.REACT_APP_TIMEOUT);
export const bsf = process.env.REACT_APP_BSF_URL_API;
export const norebaseUrl = process.env.REACT_APP_NOREBASE_NAME_CHECK;
export const cacBaseUrl = process.env.REACT_APP_CAC_VAS;
export const cacApiKey = process.env.REACT_APP_CAC_VAS_API_KEY;
export const Colors = {
  green: '#028789',
  black: '#212121',
  gray: '#D6D9E0',
  white: 'white',
  secondaryGreen: '#059964',
  secondaryGreen300: '#D4D9E0',
};

const commonEmailTypos: Record<string, string> = {
  'gamil.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.xom': 'gmail.com',
  'gamil.con': 'gmail.com',
  'gamil.xom': 'gmail.com',
  'gmeil.com': 'gmail.com',
  'gmeil.con': 'gmail.com',
  'gmeil.xom': 'gmail.com',
  'gmaill.con': 'gmail.com',
  'gmaill.xom': 'gmail.com',
  'gmail.com.xom': 'gmail.com',
  'yahho.com': 'yahoo.com',
  'yaho.com': 'yahoo.com',
  'yahho.xom': 'yahoo.com',
  'yahoo.xom': 'yahoo.com',
  'yahoo.con': 'yahoo.com',
  'hotnail.com': 'hotmail.com',
  'hotmaill.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmail.xom': 'hotmail.com',
};

export const hasTypo = (email: string) => {
  const normalizedEmail = email.trim().toLowerCase();

  const [, domain] = normalizedEmail.split('@');
  let correctedEmail = normalizedEmail;
  if (domain && commonEmailTypos[domain.toLowerCase()]) {
    correctedEmail = normalizedEmail.replace(domain, commonEmailTypos[domain.toLowerCase()]);
  }

  if (normalizedEmail !== correctedEmail) {
    return { isTypo: true, correctedEmail };
  }
  return false;
};
